import SpecializationPage from "@/components/SpecializationPage";
import { IMG } from "@/lib/images";

export default function Poliuretano() {
  return (
    <SpecializationPage
      testid="poliuretano-page"
      quoteService="Coibentazione in poliuretano"
      index="/ 04"
      title="Poliuretano"
      lines={["Coibentazione", "in poliuretano."]}
      subtitle="L'isolamento termico ad alte prestazioni: poliuretano espanso applicato a spruzzo che elimina ponti termici e abbatte i consumi energetici."
      image={IMG.insulation}
      accent="Il miglior isolante, senza compromessi."
      intro={[
        "Il poliuretano espanso a spruzzo è oggi il materiale isolante con il più alto potere coibente per unità di spessore. Applicato in forma liquida, espande e aderisce perfettamente a qualsiasi supporto, riempiendo ogni cavità.",
        "Il risultato è un cappotto termico continuo, senza fughe d'aria né ponti termici, che migliora il comfort abitativo, riduce le dispersioni e aumenta la classe energetica dell'immobile.",
      ]}
      specs={[
        { k: "Conducibilità (λ)", v: "0,022 W/mK" },
        { k: "Densità", v: "30-45 kg/m³" },
        { k: "Assorbimento acqua", v: "Minimo" },
        { k: "Ponti termici", v: "Eliminati" },
        { k: "Reazione al fuoco", v: "Euroclasse B" },
        { k: "Durata", v: "> 30 anni" },
      ]}
      benefits={[
        { t: "Massimo potere isolante", d: "La conducibilità termica più bassa: più isolamento con meno spessore." },
        { t: "Nessun ponte termico", d: "Applicazione continua che sigilla ogni cavità e giunzione." },
        { t: "Risparmio energetico", d: "Riduce sensibilmente i consumi per riscaldamento e raffrescamento." },
        { t: "Impermeabile all'aria", d: "Blocca gli spifferi e migliora il comfort in ogni stagione." },
        { t: "Leggero e strutturale", d: "Aggiunge rigidità senza appesantire le strutture esistenti." },
        { t: "Valore dell'immobile", d: "Migliora la classe energetica e il valore di mercato dell'edificio." },
      ]}
      applications={[
        "Sottotetti e mansarde",
        "Coperture e tetti (a falda e piani)",
        "Pareti perimetrali (interno ed esterno)",
        "Intercapedini murarie (insufflaggio)",
        "Solai e sottofondi di pavimenti",
        "Cappotto termico interno ed esterno",
        "Cantine e locali interrati",
        "Garage, box auto e autorimesse",
        "Capannoni industriali e magazzini",
        "Celle frigorifere e ambienti condizionati",
        "Coibentazione di serbatoi e tubazioni",
        "Container, prefabbricati e camper",
        "Stalle e ambienti agricoli",
        "Controsoffitti e vespai areati",
        "Locali tecnici e centrali termiche",
        "Nuove costruzioni e ristrutturazioni",
      ]}
      faqs={[
        { q: "Quanto isola il poliuretano espanso a spruzzo?", a: "È tra i materiali con il più alto potere isolante per unità di spessore, con una conducibilità termica molto bassa (circa 0,022 W/mK). Significa più isolamento con minor spessore rispetto ad altri materiali." },
        { q: "Elimina davvero i ponti termici?", a: "Sì. Applicato in forma liquida, espande e aderisce a ogni supporto riempiendo tutte le cavità: si ottiene un cappotto continuo senza fughe d'aria né ponti termici, a differenza dei pannelli tradizionali." },
        { q: "Dove si può applicare la coibentazione?", a: "Sottotetti, mansarde, coperture, pareti perimetrali, intercapedini murarie (insufflaggio), solai, cantine, garage, capannoni e molto altro, sia in ristrutturazione sia in nuova costruzione." },
        { q: "Quanto dura e ha bisogno di manutenzione?", a: "Il poliuretano mantiene le sue prestazioni per oltre 30 anni e non richiede manutenzione particolare una volta applicato correttamente." },
        { q: "Migliora la classe energetica dell'immobile?", a: "Sì. Riducendo sensibilmente le dispersioni termiche, migliora il comfort abitativo, abbatte i consumi e aumenta la classe energetica e il valore di mercato dell'edificio." },
      ]}
    />
  );
}
